import { isPerson, widthOf } from '@platform/core/lib/fieldTypes';
import type { FieldWidth, IFieldDefinition, IFormGroup } from '@platform/core/types';
import type { IFieldPlacement } from './IFieldPlacement';

const WIDTHS: readonly string[] = ['S', 'M', 'L'];

/**
 * Місце поля на сітці групи (UIUX forms/field-grid-and-widths, FORM_LAYOUT §3): ширина й окремий рядок — з розкладки групи у визначенні
 * форми (`layout`), інакше ширина за типом поля (widthOf), а люди (тип user) починають власний рядок. Чиста функція.
 */
export function fieldPlacementOf(group: Pick<IFormGroup, 'layout'> | undefined, field: IFieldDefinition): IFieldPlacement {
  const own = group?.layout?.find((l) => l.key === field.key);
  const width = own?.width && WIDTHS.includes(own.width) ? (own.width as FieldWidth) : widthOf(field);
  return { width, ownLine: own?.ownLine ?? isPerson(field) };
}
